import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="main-navigation">
      <div className="logo">
        <Link to="/">Nagoya Investments</Link>
      </div>
      
      <ul className="nav-links">
        <li>
          <Link to="/" className={isActive('/') ? 'active' : ''}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" className={isActive('/about') ? 'active' : ''}>
            About
          </Link>
        </li>
        <li>
          <Link to="/investment-strategy" className={isActive('/investment-strategy') ? 'active' : ''}>
            Investment Strategy
          </Link>
        </li>
        <li>
          <Link to="/solar" className={isActive('/solar') ? 'active' : ''}>
            Solar
          </Link>
        </li>
        <li>
          <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation; 